import * as yup from "yup";
import { useFormik } from "formik";
import { tAuth } from "../../../i18n/useAppTranslation";

const schema = yup.object({
  email: yup
    .string()
    .email(tAuth("formError.emailInvalid"))
    .required(tAuth("formError.emailRequired")),

  password: yup.string().required(tAuth("formError.passwordRequired")),
});

export function useFormLogin({ onSubmit }) {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    isValid,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: schema,
    onSubmit,
  });

  const hasError = (field) => {
    return Boolean(errors[field] && touched[field]);
  };

  return {
    form: values,
    isFormValid: isValid,
    hasError,
    submit: handleSubmit,
    onFormValueChange: handleChange,
    onFormValueBlur: handleBlur,
    errors,
  };
}
